export class WidgetCollection {
    constructor(client) {
        /**
         * @type {AutocompleteBar[]} All the autocomplete bar widgets
         */
        this.autocompleteBar = [];
        /**
         * @type {GroupedSearchBar[]} All the grouped search bar widgets
         */
        this.groupedSearchBar = [];
        /**
         * @type {Result[]} All the result widgets
         */
        this.result = [];
        /**
         * @type {AggregationBar[]} All the aggregation bar widgets
         */
        this.aggregationBar = [];
        this.client = client;
    }
    add(widget) {
        switch (widget.discriminator) {
            case 'AutocompleteBar':
                this.autocompleteBar.push(widget);
                break;
            case 'GroupedSearchBar':
                this.groupedSearchBar.push(widget);
                break;
            case 'Result':
                this.result.push(widget);
                break;
            case 'AggregationBar':
                this.aggregationBar.push(widget);
                break;
            default:
                // If the widget does not have an array throw an error
                console.error(widget);
                throw new Error('Unsupported widget: ' + widget.discriminator);
        }
        widget.setClient(this.client)
            .build();
    }
    addMultiple(widgets) {
        widgets.forEach((widget) => {
            this.add(widget);
        });
    }
}
